/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Ledg API
 * API for managing financial activities and transactions
 * OpenAPI spec version: 2.0.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import type { AppConfigResponse } from "./client.schemas";

/**
 * @summary Get application configuration
 */
export const getAppConfig = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AppConfigResponse>> => {
  return axios.default.get(`/v2/app_config`, options);
};

export const getGetAppConfigQueryKey = () => {
  return [`/v2/app_config`] as const;
};

export const getGetAppConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getAppConfig>>,
  TError = AxiosError<string>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAppConfig>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAppConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppConfig>>> = ({
    signal,
  }) => getAppConfig({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAppConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAppConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAppConfig>>
>;
export type GetAppConfigQueryError = AxiosError<string>;

/**
 * @summary Get application configuration
 */
export const useGetAppConfig = <
  TData = Awaited<ReturnType<typeof getAppConfig>>,
  TError = AxiosError<string>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAppConfig>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAppConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
